<template>
  <main-layout>
    <template v-if="isMobile">
      <livechat-mobile></livechat-mobile>
    </template>
    <template v-else>
      <livechat></livechat>
    </template>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Livechat from './Livechat.vue'
import LivechatMobile from './LivechatMobile'
import moment from 'moment'

export default {
  data: () => ({
    isMobile: false
  }),
  components: {
    Livechat,
    LivechatMobile
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    currentTheme() {
      return this.$store.state.livechat.theme ? this.$store.state.livechat.theme : this.currentTheme
    },
    currentPageid() {
      return this.$store.state.livechat.pageid
        ? this.$store.state.livechat.pageid
        : this.selectedBot.pageid
    }
  },
  created() {
    if (!this.$store.state.livechat.pageid) {
      this.$store.commit('SELECT_PAGE_LIVECHAT', {
        value: this.selectedBot.pageid,
        theme: this.selectedBot.theme
      })
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  beforeMount: function () {
    var bot = this.botlist.find((el) => {
      return el.pageid == this.$store.state.livechat.pageid
    })
    if (
      !bot ||
      !(
        (bot && this.$store.state.livechatPageList.includes(bot.theme)) ||
        this.$store.state.livechatPageIdList.includes(this.$store.state.livechat.pageid) ||
        (bot.theme == 'ecommercebasic' && this.$store.state.livechat.pageid == '270028443161479')
      )
    ) {
      this.$router.push('/' + this.$store.getters.currentLang + '/dashboard')
    }
  },

  mounted() {
    var vm = this
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
    if (this.currentTheme == 'universalutilities') {
      vm.$store.dispatch('loadLinePushMessageCount', {
        dateform: moment().startOf('month').format('YYYY-MM-DD'),
        dateto: moment().endOf('month').format('YYYY-MM-DD')
      })
    }

    if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
      this.$store.dispatch('loadAstonAdmins')
    }
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 960
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatView.vue